import React from 'react'

const ExtensionPrivacy = () => {
    return (
        <>
            <iframe
                title="extension privacy policy"
                src="/extension-privacy.html"
                style={{
                    width: '100%',
                    height: '100vh',
                    border: 'none'
                }}
            />
        </>
    );
}

export default ExtensionPrivacy